<app-pagetitle title="Ambientes" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row">
                    <div class="col-sm-6 text-sm-right">
                        <button *hasPermission="{app: constant.AMBIENTES, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()"><i
                                class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <span class="col-3" *ngFor="let data of ambientes">{{data.idSprAmbiente}} - {{data.nombreCorto}} - {{data.estado}}</span>
            </div>
             -->

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nivel</th>
                            <th>Unidad</th>
                            <th>Nombre corto</th>
                            <th>Subsistema</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let ambiente of ambientes; let indice=index">
                            <td>{{indice+1}}</td>
                            <td>{{ambiente.nivel.nombre}}</td>
                            <td>{{ambiente.nombreUnidad}}</td>
                            <td>{{ambiente.nombreCorto}}</td>
                            <td>{{ambiente.subsistema.nombre}}</td>
                            <td>{{((ambiente.estado == '1')? 'Activo': 'Inactivo')}}</td>
                            <td class="text-center" style='white-space: nowrap'>
                                <button *hasPermission="{app: constant.AMBIENTES, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Editar este registro" (click)="edit(ambiente)">
                                    <i class="fas fa-pencil-alt fa-lg"></i>
                                </button>
                                <button *hasPermission="{app: constant.AMBIENTES, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect" title="Eliminar este registro" (click)="delete(ambiente.idSprAmbiente)">
                                    <i class="fas fa-trash-alt fa-lg"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="del" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>

<!-- MODAL PARA CREAR Y EDITAR -->
<jw-modal id="new">
    <div class="modal-dialog modal-lg" style="padding-top: 6%;">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">AMBIENTES</h3>
                <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-6">

                        <h4 class="header-title">Estructura organizacional Siipne</h4>
                        <!-- <p class="sub-header font-13">
                            <span *ngIf="selectedFile">{{selectedFile.label}}</span>
                        </p> -->
                        <div class="card flex justify-content-center">
                            <p-tree [value]="dataUnidadesTree" [filter]="true" selectionMode="single" [(selection)]="selectedFile" (onNodeSelect)="nodeSelect($event)" scrollHeight="400px" (onNodeExpand)="nodeExpand($event)">
                            </p-tree>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h4 class="header-title">Gestion ambientes</h4>
                        <!-- <p class="sub-header font-13">
                        </p> -->

                        <div class="col-md-12">
                            <div class="card flex justify-content-center">
                                <p-tree [value]="dataAmbientesTree" selectionMode="single" [(selection)]="selectedFileAmbientes" (onNodeSelect)="nodeSelectAmbientes($event)" scrollHeight="400px" (onNodeExpand)="nodeExpandAmbientes($event)">
                                </p-tree>
                            </div>
                        </div>

                        <form class="needs-validation" novalidate id="formComun" [formGroup]="formAmbiente">
                            <input type="hidden" id="idSprAmbiente" formControlName="idSprAmbiente">
                            <input type="hidden" id="idDgpUnidad" formControlName="idDgpUnidad">

                            <div class="form-floating mb-2">
                                <input type="text" id="unidadPadre" class="form-control form-control-sm" style="background-color: #e9e8e8"   value= {{nombreUnidadPadre}} readonly="true"/>
                                <label for="unidadPadre">Unidad Padre</label>
                            </div>

                            <div class="form-floating mb-2">
                                <select (change)="mensajeAmbientePadre($event)" id="idSprSubsistema" class="form-select" formControlName="idSprSubsistema" required>
                                    <option>Seleccione</option>
                                    <option *ngFor="let item of subsistemas" [value]="item.idSprSubsistema">
                                        {{item.nombre}}</option>
                                </select>
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['idSprSubsistema'].errors">Campo
                                    requerido</small>
                                <label for="idSprSubsistema">Subsistema</label>
                            </div>
                            <div class="form-floating mb-2">
                                <select (change)="mensajeAmbientePadre($event)" id="idSprNivel" class="form-select form-control-sm" formControlName="idSprNivel" required [ngClass]="{'is-invalid': this.formAmbiente.get('idSprNivel')?.errors  && this.submitted,  'is-valid': this.formAmbiente.value.idSprNivel}">
                                    <option *ngFor="let item of niveles" [value]="item.idSprComun">{{item.nombre}}
                                    </option>
                                </select>
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['idSprNivel'].errors">Campo
                                    requerido</small>
                                <label for="idSprNivel">Nivel</label>
                            </div>
                            <div class="form-floating mb-2">
                                <input type="text" id="nombreUnidad" class="form-control form-control-sm" formControlName="nombreUnidad" oninput="this.value = this.value.toUpperCase();" required [ngClass]="{
                                        'is-invalid': this.formAmbiente.get('nombreUnidad')?.errors && this.submitted,
                                        'is-valid': !this.formAmbiente.get('nombreUnidad')?.errors,
                                      }" />
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['nombreUnidad'].errors">Campo
                                    requerido
                                </small>
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['idDgpUnidad'].errors">No se
                                    ha selecionado la Unidad del árbol</small>
                                <label for="nombreUnidad">Nombre</label>
                            </div>
                            <div class="form-floating mb-2">
                                <input type="text" id="nombreCorto" class="form-control form-control-sm" formControlName="nombreCorto" oninput="this.value = this.value.toUpperCase();" required [ngClass]="{
                                        'is-invalid': this.formAmbiente.get('nombreCorto')?.errors && this.submitted,
                                        'is-valid': !this.formAmbiente.get('nombreCorto')?.errors,
                                      }" />
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['nombreCorto'].errors">Campo
                                    requerido
                                </small>
                                <label for="nombreCorto">Nombre corto</label>
                            </div>
                            <div class="form-floating mb-2">
                                <input type="date" id="fechaInicio" class="form-control form-control-sm" formControlName="fechaInicio" oninput="this.value = this.value.toUpperCase();" required [ngClass]="{'is-invalid': this.formAmbiente.get('fechaInicio')?.errors && this.submitted,'is-valid': !this.formAmbiente.get('fechaInicio')?.errors,}"
                                    date>
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['fechaInicio'].errors">Campo
                                    requerido
                                </small>
                                <label for="fechaInicio">Fecha inicio</label>
                            </div>
                            <div class="form-floating mb-2">
                                <input type="date" id="fechaFin" class="form-control form-control-sm" formControlName="fechaFin" oninput="this.value = this.value.toUpperCase();" required [ngClass]="{'is-invalid': this.formAmbiente.get('fechaFin')?.errors && this.submitted,'is-valid': !this.formAmbiente.get('fechaFin')?.errors,}"
                                    date>
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['fechaFin'].errors">Campo
                                    requerido
                                </small>
                                <label for="fechaFin">Fecha fin</label>
                            </div>

                            <!-- <div class="form-floating mb-2">
                                <textarea type="text" id="descripcion" class="form-control form-control-sm"
                                    formControlName="descripcion" required autofocus placeholder="descripcion"
                                    [ngClass]="{'ng-invalid ng-dirty' : submitted && ambFrm['descripcion'].errors}"></textarea>
                                <small class="invalid-feedback" *ngIf="submitted && ambFrm['descripcion'].errors">Campo
                                    requerido.
                                </small>
                                <label for="descripcion">descripcion</label>
                            </div> -->
                            <div class="form-floating mb-2">
                                <select id="estado" class="form-select" formControlName="estado" required="true" [ngClass]="{
                                    'is-invalid': this.formAmbiente.get('estado')?.errors && this.submitted,
                                    'is-valid': !this.formAmbiente.get('estado')?.errors, }">
                                    <option value="1" selected>Activo</option>
                                    <option value="2">Inactivo</option>
                                </select>
                                <label for="estado">Estado</label>
                                <small class="invalid-feedback" *ngIf="this.formAmbiente.get('estado')?.errors?.['required'] && this.submitted">
                                    Campo
                                    requerido</small>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModal()">Cerrar</button>
                <button *hasPermission="{app: constant.AMBIENTES, permission: [constant.CREAR, constant.ACTUALIZAR]}" type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>